/**
 * Constants for the Help Center CTA — used by the topbar icon, the company
 * three-dot menu item, and the openHelpCenter helper.
 */
export const HELP_CENTER_LABEL = 'Help Center';

/**
 * Used by `openHelpCenter()` when `REACT_APP_HELP_CENTER_URL` is unset.
 * Defaults to the production help center so a forgotten env var doesn't
 * silently open a localhost URL in deployed environments. Local dev sets
 * REACT_APP_HELP_CENTER_URL explicitly to point at a local help center.
 */
export const HELP_CENTER_DEFAULT_URL = 'https://helpcenter.aicatech.in';
